import React from "react";
import styles from "./StatCard.module.scss";

export type StatCardTone = "default" | "success" | "warning" | "danger";

interface StatCardProps {
	label: string;
	value: string | number;
	/** Colours the figure with the matching status token; the label stays neutral. */
	tone?: StatCardTone;
	className?: string;
}

/**
 * A headline figure with its label, for the summary row above a table
 * (e.g. "Total Refunds — 248"). Lay several out in a grid on the page.
 */
const StatCard: React.FC<StatCardProps> = ({ label, value, tone = "default", className = "" }) => {
	return (
		<div className={`${styles.card} ${styles[tone]} ${className}`}>
			<span className={styles.label}>{label}</span>
			<span className={styles.value}>{value}</span>
		</div>
	);
};

export default StatCard;
